// Module
var code = "<kform-builder-conditional></kform-builder-conditional> ";
// Exports
export default code;